<template>
  <div :class="{ 'next-background': mode === 'home' }">
    <mainindex>
      <div
        v-if="!islogmode"
        class="content"
      >
        <!--<div class="content" v-if="gen._UID && !islogmode">-->
        <!--HEADER-->
        <page-header
          v-if="mode !== 'home'"
          :menu-tree="menu"
          :cur-page="mode"
          @nav="go($event)"
          @save-prj="savePrj()"
          @clone-prj="cloneProject()"
          @new-prj="newPrj"
          @openlogspanel="toggleLogsPanel"
        ></page-header>
        <!--HEADER-->
        <!--BODY-->
        <div class="body" :class="[paddingClass]">
          <router-view v-if="$route.name !== null"></router-view>
          <div v-else>
            <template v-if="mode==='home' && $route.name !== 'guestRegister' && $route.name !== 'resetPassword' && $route.name !== 'guestResetPassword'">
              <home
                @new-prj="newPrj"
                @load-prj="!user.guest ? go('projects.my') : go('projects.guest')"
                @nav="go($event)"
              ></home>
            </template>
            <template v-else-if="mode==='startprj'">
              <start-prj @nav="go($event)"></start-prj>
            </template>
            <template v-else-if="mode==='projects.guest' && user.guest">
              <prj-finder
                key="CUSTOMER"
                filter="GUEST"
                title="My Projects"
                :rows-number="5"
                order-by="11D"
                :cols="[
                { id:'guest.fullname', title:_trans('customer name'), order:5 },
                { id:'id', title:'id', order:0 },
                { id:'des', title:'name', order:6 },
                { id:'shop', title:'shop', order:8 },
                { id:'status', title:'status', order:4 },
                { id:'lastedit', title:'last edit', order:11}
              ]"
                @open="openPrj($event)"
              ></prj-finder>
            </template>
            <template v-else-if="mode==='projects.my' && !user.guest">
              <prj-finder
                key="MY"
                filter="MY"
                title="My Projects"
                :rows-number="5"
                order-by="11D"
                :cols="[
                { id:'guest.fullname', title:_trans('customer name'), order:5 },
                { id:'id', title:'id', order:0 },
                { id:'des', title:'name', order:6 },
                { id:'shop', title:'shop', order:8 },
                { id:'status', title:'status', order:4 },
                { id:'lastedit', title:'last edit', order:11}
              ]"
                @open="openPrj($event)"
              ></prj-finder>
            </template>
            <template v-else-if="mode==='projects.ext' && !user.guest">
              <prj-finder
                key="OTHERPRJ"
                filter="OTHERPRJ"
                title="Other Projects In My Store"
                :rows-number="5"
                order-by="11D"
                :cols="[
                { id:'guest.fullname', title:_trans('customer name'), order:5 },
                { id:'id', title:'id', order:0 },
                { id:'des', title:'name', order:6 },
                { id:'shop', title:'shop', order:8 },
                { id:'status', title:'status', order:4 },
                { id:'lastedit', title:'last edit', order:11},
                { id:'assign', title:null }
              ]"
                @open="openPrj($event)"
              ></prj-finder>
            </template>
            <template v-else-if="mode==='projects.clinv' && !user.guest">
              <prj-finder
                key="CLOSED"
                filter="CLOSED"
                title="Closed Projects"
                :rows-number="5"
                order-by="11D"
                :cols="[
                { id:'guest.fullname', title:_trans('customer name'), order:5 },
                { id:'id', title:'id', order:0 },
                { id:'des', title:'name', order:6 },
                { id:'shop', title:'shop', order:8 },
                { id:'status', title:'status', order:4 },
                { id:'lastedit', title:'last edit', order:11},
                { id:'assign', title:null }
              ]"
                @open="openPrj($event)"
              ></prj-finder>
              <prj-finder
                key="INACTIVE"
                filter="INACTIVE"
                title="Inactive Projects"
                :rows-number="5"
                order-by="11D"
                :cols="[
                { id:'guest.fullname', title:_trans('customer name'), order:5 },
                { id:'id', title:'id', order:0 },
                { id:'des', title:'name', order:6 },
                { id:'shop', title:'shop', order:8 },
                { id:'status', title:'status', order:4 },
                { id:'lastedit', title:'last edit', order:11},
                { id:'assign', title:null }
              ]"
                @open="openPrj($event)"
              ></prj-finder>
            </template>
            <template v-else-if="mode==='notifications'">
              <notifications></notifications>
            </template>
            <template v-else-if="mode==='itemsearch'">
              <article-search @nav="go($event)"></article-search>
            </template>
            <template v-else-if="mode === 'renders'">
              <renders @nav="go($event)" />
            </template>
            <template v-else-if="mode==='configurator'">
              <configure
                :update-picture="false"
                @nav="go($event)"
              ></configure>
            </template>
            <template v-else-if="mode==='3dview' || mode === 'planner'">
              <view3d
                :load-header-on-start="true"
                @nav="go($event)"
              />
            </template>
            <template v-else-if="mode==='2dview'">
              <view2d
                :load-header-on-start="true"
                @nav="go($event)"
              />
            </template>
            <template v-else-if="mode==='compositions'">
              <compositions
                :apply-header="true"
                @nav="go($event)"
              />
            </template>
            <template v-else-if="mode==='offerview'">
              <offer @nav="go($event)"></offer>
            </template>
            <template v-else-if="mode==='summary'">
              <prj-summary @nav="go($event)" />
            </template>
            <template v-else-if="mode==='customerinfo'">
              <customer-info @nav="go($event)" />
            </template>
            <template v-else-if="mode==='prjlog'">
              <prj-log @nav="go($event)" />
            </template>
            <template v-else-if="mode==='delivery'">
              <delivery @nav="go($event)" />
            </template>
            <template v-else-if="mode==='promotions'">
              <promotions @nav="go($event)" />
            </template>
            <template v-else-if="mode === 'myprofile'">
              <my-profile @nav="go($event)" />
            </template>
            <template v-else-if="mode==='json'">
              <d-json :value="prj" />
            </template>
            <template v-else>
              <h1>::::{{ mode }}::::</h1>
            </template>
          </div>
        </div>
        <!--BODY-->
      </div>
      <home
        v-else
        @new-prj="newPrj"
        @load-prj="go('projects.my')"
        @nav="go($event)"
      ></home>
    </mainindex>
    <app-settings
      v-if="showSettings"
      @close="showSettings = false"
    ></app-settings>

    <b-alert
      v-if="isMaintenance && (!$store.state.commonStore.profile || ($store.state.commonStore.profile && $store.state.commonStore.profile.guest))"
      class="position-fixed fixed-bottom m-0 rounded-0"
      style="z-index: 2000;"
      variant="warning"
      show
    >
      <span class="text-center">
        <span v-text="_trans('Maintenance from')"></span>
        <span v-text="$store.state.commonStore.startDateTimeUTC"></span>
        <span v-text="_trans('to')"></span>
        <span v-text="$store.state.commonStore.endDateTimeUTC"></span>
      </span>
    </b-alert>
    <b-modal
      v-else-if="isMaintenance && $store.state.commonStore.profile"
      variant="warning"
      size="xl"
      visible
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
      hide-header
      centered
    >
      <div class="py-5 px-3 text-center">
        <h1>
          <span v-text="_trans('Maintenance from')"></span>
          <span v-text="$store.state.commonStore.startDateTimeUTC"></span>
          <span v-text="_trans('to')"></span>
          <span v-text="$store.state.commonStore.endDateTimeUTC"></span>
        </h1>
        <div v-if="$store.state.commonStore.profile.admin" class="d-flex justify-content-center mt-4">
          <b-btn variant="secondary" v-text="_trans('Unlock manteinance')" @click="unlockManteinance"></b-btn>
        </div>
      </div>
    </b-modal>

    <div class="d-flex">
      <b-btn v-if="$store.state.commonStore.profile && $store.state.commonStore.profile.admin && !isMaintenance" class="mx-auto" variant="danger" v-text="_trans('Lock manteinance')" @click="lockManteinance"></b-btn>
    </div>
  </div>
</template>
<script>
import "../../scss/next.scss";
import index from "@configurator/index";

export default {
    mixins: [index],
};
</script>
<style scoped lang="scss">
  .no-menu {
    padding-top: 0;
  }

  .mid-menu {
    padding-top: 90px;
    //padding-top: 2.512rem;
    @include media-breakpoint-down(md) {
    }
  }

  .full-menu {
    padding-top: 131px;
    @include media-breakpoint-down(md) {
      //padding-top: 5.15rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/configurator/start.vue